<script setup lang="ts">
import BlockRenderer from '~/components/BlockRenderer.vue'

const props = defineProps<{
  block: { component: string; props: Record<string, unknown> }
}>()

const failed = ref(false)
const errorMessage = ref('')

onErrorCaptured((error) => {
  failed.value = true
  errorMessage.value = error instanceof Error ? error.message : 'Block render failed'
  console.error(`[block:${props.block.component}]`, error)
  return false
})

watch(
  () => props.block.component,
  () => {
    failed.value = false
    errorMessage.value = ''
  },
)
</script>

<template>
  <div
    v-if="failed"
    class="border-destructive/30 bg-destructive/5 text-destructive mx-auto my-2 max-w-5xl rounded-lg border px-4 py-3 text-sm"
    role="alert"
  >
    این بخش قابل نمایش نیست.
    <span class="sr-only">{{ errorMessage }}</span>
  </div>
  <BlockRenderer
    v-else
    :block="block"
  />
</template>
